import React, { Component } from 'react'
import _ from 'lodash'
import queryString from 'query-string'
import I18n from '../lib/i18n'
import { withRouter } from 'react-router-dom'
import withTracker from '../lib/withTracker'
import withStore from '../lib/withStore'
import withHeader from '../lib/withHeader'
import fetchContentGroupsData from '../lib/fetchContentGroupsData'
import PageMiddleSpinner from '../components/PageMiddleSpinner'
import ProductSearchResultList from '../components/ProductSearchResultList'
import EmptyProductSearchResult from '../components/EmptyProductSearchResult'
import Toast from '../components/Toast'
import AddToCartBottomSheet from '../components/AddToCartBottomSheet'
import * as StyledComponent from '../styles'
import * as API from '../api'
import Analytics from '../lib/analytics'
import * as ScrollViewControl from '../lib/scrollViewControl'

class ProductSearchResult extends Component {

  // toast timer reference
  toast_timer

  constructor(props) {
    super(props)

    this._lastScrollPosition = null
    this._toast = null
    this.state = {
      loading: false,
      keyword: '',
      skus: [],
      skus_pagination: {},

      // add to cart props
      is_bottom_sheet_open: false,
      selected_item: {
        product: {},
        color_option_id: ''
      },
      add_to_bag_loading: false,
      add_to_bag_loading_id: '',
      search_param: 'q'
    }
  }

  componentDidMount() {
    // fetch for content_groups if it is not already in store
    _.isEmpty(this.props.store.content_groups) &&
    fetchContentGroupsData().then(content_group_data => {
      this.saveToStore(content_group_data)
    })

    window.addEventListener('scroll', this.handleScroll);
    this.handleURLChange()
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    const { search } = this.props.location

    if (this.props.store.product_group_titles_hash !== prevProps.store.product_group_titles_hash) {
      const { search } = this.props.location
      const keyword = decodeURIComponent(_.replace(search, /\?.+(=)/g, ''))

      this.setProductGroupTitle(keyword)
    }

    if (_.startsWith(search, '?category_code_eq=')) {
      const current_categoy_code = _.replace(search, '?category_code_eq=', '')
      const prev_category_code = _.replace(prevProps.location.search, '?category_code_eq=', '')
      if (current_categoy_code !== prev_category_code) {
        this.handleURLChange()
      }
    }

    if (_.startsWith(search, '?q=')) {
      const current_search_keyword = _.replace(search, '?q=', '')
      const prev_search_keyword = _.replace(prevProps.location.search, '?q=', '')

      if (current_search_keyword !== prev_search_keyword) {
        this.handleURLChange()
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    clearTimeout(this.toast_timer)
  }

  handleURLChange = () => {
    const { search } = this.props.location
    const keyword = decodeURIComponent(_.replace(search, /\?.+(=)/g, ''))
    const query = queryString.parse(search)
    const search_param = _.keys(query)[0]

    if (!_.isEmpty(search_param)) {
      this.submitSearch(keyword, search_param)
    }
  }

  handleClearSearch = () => {
    this.setState({ keyword: '' })
  }

  submitSearch = (value, search_param = 'q') => {
    if (search_param === 'q') {
      this.setState({
        invisible_keyword: '',
        keyword: value,
        search_param,
        loading: true,
        skus: [],
        product_group_title: ''
      }, () => {
        this.fetchProducts(value)
        this.props.history.push(`/${I18n.currentLocale()}/search?q=${value}`)
        // track event
        Analytics.event({ category: 'Minicart - Search', action: 'Keyword Search', label: value })
      })
    } else {
      this.setState({
        invisible_keyword: value,
        loading: true,
        skus: [],
        product_group_title: '',
        search_param
      }, () =>
        this.fetchProducts(value)
      )
      this.setProductGroupTitle(value)
    }
  }

  setProductGroupTitle(code) {
    const { product_group_titles_hash } = this.props.store
    const lower_case_code = code.toLowerCase()

    // set the title if keyword matches the cheat codes
    !_.isEmpty(lower_case_code, product_group_titles_hash, product_group_titles_hash[lower_case_code]) &&
      this.setState({ product_group_title: product_group_titles_hash[lower_case_code] })
  }

  toggleBottomSheet = (open) => {
    if (open) {
      // when bottom sheet is ready and open, will call `handleBottomSheetOpen`
      // to prevent scrolling the background
      this.setState({ is_bottom_sheet_open: true })
    } else {
      // re-enable background scrolling
      ScrollViewControl.allowScrolling()
      window.pageYOffset !== this._lastScrollPosition && window.scrollTo(0, this._lastScrollPosition)
      // reset the selected items when closing bottom sheet
      this.setState({
        is_bottom_sheet_open: false,
        add_to_bag_loading: false,
        add_to_bag_loading_id: '',
        selected_item: {
          product: {},
          color_option_id: ''
        }
      })
    }
  }

  // prevent scrolling the background
  handleBottomSheetOpen = () => {
    this._lastScrollPosition = window.pageYOffset
    ScrollViewControl.preventScrolling()
    document.documentElement.style.top = `-${this._lastScrollPosition}px`
  }

  fetchProducts = async (keyword, page = 1) => {
    try {
      const fetch_product_res = await API.fetchProducts(keyword, this.state.search_param, page)
      const { data = {} } = fetch_product_res
      const { skus = [], skus_pagination = {} } = data
      const new_skus = _.concat(this.state.skus, skus)

      this.setState({
        skus: new_skus,
        skus_pagination,
        loading: false
      })
    } catch(err) {
      const errors = API.handleError(err)

      this.saveToStore({ alert_message: errors.error_message }, () => this.props.store.flash.open())
    }
  }

  // show success message
  handleAddToBagSuccess = (sku) => {
    // update the shopping bag icon quantity
    this.saveToStore({ cart_total_items: this.props.store.cart_total_items + 1 })
    this.toast_timer = setTimeout(() => {
      !_.isNull(this._toast.open) && this._toast.open()
    }, 200)
    // track event
    const { product } = _.get(this.state, 'selected_item')

    Analytics.execute({
      plugin_name: 'ec',
      action: 'addProduct',
      payload: {
        'id': sku.code,
        'name': product && product.title,
        'price': sku.sell_price,
        'quantity': 1
      }
    })
    Analytics.execute({
      plugin_name: 'ec',
      action: 'setAction',
      action_type: 'add'
    })
    Analytics.pageview({
      page: this.props.location.pathname,
      title: I18n.t('containers.product_search_result.title')
    })
    Analytics.event({ category: 'Minicart - Search', action: 'Add to Bag', label: sku.code })
  }

  // handle process after user click add to bag button
  handleAddToBag = _.throttle((params = {}) => {
    // if already processing add to bag, stop handling other add to bag
    if (this.state.add_to_bag_loading) return
    //
    const { product = {}, color_option_id } = params
    this.setState({
      add_to_bag_loading: true,
      add_to_bag_loading_id: product.id,
      selected_item: {
        product,
        color_option_id
      }
    }, () => {
      this.toggleBottomSheet(true)
    })
  }, 300, { trailing: false })

  saveToStore = (state, cb) => {
    this.props.store.save({ ...state }, cb)
  }

  loadMore = () => {
    const { next_page } = this.state.skus_pagination

    if (next_page && !this.state.loading) {
      this.setState({ loading: true }, () => {
        this.fetchProducts(this.state.keyword || this.state.invisible_keyword, next_page)
      })
    }
  }

  handleScroll = _.throttle(() => {
    if ("activeElement" in document) document.activeElement.blur()
  }, 500, {trailing: false})

  render() {
    const {
      keyword,
      loading,
      skus,
      skus_pagination,
      add_to_bag_loading,
      add_to_bag_loading_id,
      product_group_title,
      selected_item
    } = this.state
    
    return <StyledComponent.PageContainer id='scroll-view'>
      {
        !_.isEmpty(skus)
          ? <ProductSearchResultList
              title={product_group_title}
              skus={skus}
              skus_pagination={skus_pagination}
              loadMore={this.loadMore}
              add_to_bag_loading={add_to_bag_loading}
              add_to_bag_loading_id={add_to_bag_loading_id}
              onAddToBag={this.handleAddToBag}
            />
          : loading
            ? <PageMiddleSpinner loading={loading} />
            : keyword.length >= 3
              ? <EmptyProductSearchResult keyword={keyword} />
              : <EmptyProductSearchResult />
      }
      {
        this.state.is_bottom_sheet_open &&
          <AddToCartBottomSheet
            {...selected_item}
            open={this.state.is_bottom_sheet_open}
            onAddToBagSuccess={this.handleAddToBagSuccess}
            onClose={this.toggleBottomSheet.bind(this, false)}
            onOpen={this.handleBottomSheetOpen}
          />
      }
      <Toast
        ref={ref => this._toast = ref}
        body={I18n.t('containers.product_search_result.added_to_bag')}
      />
    </StyledComponent.PageContainer>
  }
}

export default withTracker(withStore(withRouter(withHeader(ProductSearchResult))), {
  title: I18n.t('containers.product_search_result.title')
})



// WEBPACK FOOTER //
// ./src/containers/ProductSearchResult.js